export const trackEvent = (name: string, duration: number) => {
    // eslint-disable-next-line prefer-destructuring
    const rg4js = (window as any).rg4js;
    if (rg4js) {
        rg4js("trackEvent", {
            type: "customTiming",
            name,
            duration,
        });
    }
};
